<template>
    <div class="com-item global-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky global-module__root"
                :style="{
                    backgroundColor: modata.WContent.bgColor || 'transparent',
                    color: modata.WContent.textColor || ''
                }"
            >
                <!-- <div class="global-module__head">
                    <div class="global-module__head-inner">
                        <p class="global-module__en">{{ modata.WContent.enTitle }}</p>
                        <p class="global-module__cn">{{ modata.WContent.cnTitle }}</p>
                        <div class="global-module__desc ql-editor" v-html="modata.WContent.describe"></div>
                    </div>
                </div> -->
                <div class="titleModule">
                    <titleModule v-bind:modata="modata"></titleModule>
                </div>

                <div class="global-module__world">
                    <div class="global-module__world-inner">
                        <div class="global-module__world-left">
                            <div class="global-module__headquarters">
                                <div class="global-module__headquarters-img">
                                    <img
                                        v-if="modata.WContent.headImg"
                                        :src="modata.WContent.headImg"
                                        class="global-module__head-img"
                                    />
                                </div>
                                <div class="global-module__headquarters-text">
                                    <p class="global-module__head-city">{{ modata.WContent.headCity }}</p>
                                    <p class="global-module__head-title">{{ modata.WContent.headTitle }}</p>
                                </div>
                            </div>
                            <div
                                class="global-module__type-list"
                                v-if="modata.WContent.typeCards && modata.WContent.typeCards.length"
                            >
                                <div
                                    v-for="(item, i) in modata.WContent.typeCards"
                                    :key="i"
                                    class="global-module__type-card"
                                >
                                    <img
                                        v-if="item.imgUrl"
                                        :src="item.imgUrl"
                                        class="global-module__type-img"
                                    />
                                    <p class="global-module__type-name">{{ item.title }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="global-module__world-right">
                            <img
                                v-if="modata.WContent.bgImg"
                                :src="modata.WContent.bgImg"
                                class="global-module__world-img"
                            />
                        </div>
                    </div>
                </div>

                <div
                    class="global-module__cities"
                    v-if="modata.WContent.cityItems && modata.WContent.cityItems.length"
                >
                    <div class="global-module__cities-inner">
                        <div
                            v-for="(item, i) in modata.WContent.cityItems"
                            :key="i"
                            class="global-module__city"
                            :class="{'global-module__3': item.typeIds && item.typeIds.length > 2}"
                        >
                            <p class="global-module__city-name">{{ item.cityName }}</p>
                            <div
                                v-if="item.typeIds && item.typeIds.length"
                                class="global-module__city-types"
                            >
                                <template v-for="(tid, ti) in item.typeIds">
                                    <img
                                        v-if="getTypeImg(tid)"
                                        :key="ti"
                                        :src="getTypeImg(tid)"
                                        class="global-module__city-type-img"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import titleModule from "@/components/Custom/Title";
export default {
    name: "global-module",
    components: {titleModule},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'global',
                    Title: '全球布局',
                    MID: 21,
                    WID: null,
                    ModuleName: 'globalModule',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        getTypeImg(typeId) {
            if (!typeId) return ''
            const typeCards = (this.modata && this.modata.WContent && this.modata.WContent.typeCards) || []
            const t = typeCards.find(tc => tc && tc.id === typeId)
            return t ? t.imgUrl : ''
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.global-module {
    .global-module__root {
        min-height: 300px;
        padding: 5% 0;
    }

    .global-module__head {
        .global-module__head-inner {
            width: 90%;
            max-width: 1600px;
            margin: 0 auto;
        }
    }

    .global-module__en {
        line-height: normal;
        font-size: 20px;
        font-family: "pingfang medium", "PingFang SC", "Microsoft YaHei", sans-serif;
        text-align: center;
        color: rgba(1, 79, 164, 1);
    }

    .global-module__cn {
        line-height: normal;
        font-size: 42px;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        text-align: center;
    }

    .global-module__desc {
        font-size: 16px;
        color: rgba(78, 78, 78, 1);
        line-height: 1.8;
        min-height: 0;
        margin-bottom: 1%;
        text-align: center;
        ::v-deep p { margin: 0 0 8px; }
    }

    .global-module__world {
        .global-module__world-inner {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            width: 90%;
            max-width: 1600px;
            margin: 0 auto;
            margin-top: 1%;
        }
    }

    .global-module__world-left {
        flex: 0 0 28%;
        margin-right: auto;
        padding-right: 2%;
        align-self: center;
    }

    .global-module__world-right {
        flex: 1;
        max-width: 100%;
        max-height: 100%;
    }

    .global-module__world-img {
        overflow: hidden;
        max-width: 1104px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1%;

        img { width: 100%; height: 100%; object-fit: contain; }
    }

    .global-module__headquarters {
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 14%;
        padding-bottom: 12px;
    }

    .global-module__headquarters-img {
        width: 100%;
        overflow: hidden;
        border-radius: 5px 5px 0 0;
    }

    .global-module__head-img {
        width: 100%;
        display: block;

        img { width: 100%; height: auto; object-fit: contain; display: block; }
    }

    .global-module__headquarters-text {
        padding: 12px 14px 4px;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .global-module__head-city {
        line-height: normal;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 28px;
        color: #000;
    }

    .global-module__head-title {
        line-height: normal;
        font-size: 18px;
        font-family: "pingfang medium", "PingFang SC", "Microsoft YaHei", sans-serif;
        color: rgba(115, 115, 115, 1);
    }

    .global-module__type-list {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        max-width: 100%;
    }

    .global-module__type-card {
        flex: 0 0 33.3%;
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(100% / 3);
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-bottom: 10%;
    }

    .global-module__type-img {
        overflow: hidden;
        width: 28px;
        margin-right: 5px;

        img { width: 100%; height: 100%; object-fit: contain; }
    }

    .global-module__type-name {
        line-height: normal;
        font-size: 15px;
        color: rgba(115, 115, 115, 1);
        align-self: center;
        flex: 1;
    }

    .global-module__cities {
        .global-module__cities-inner {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            width: 90%;
            max-width: 1600px;
            margin: 0 auto;
            background-color: rgb(233 238 244);
            padding: 2%;
            margin-top: 0;
            border-radius: 10px;
            z-index: 111;
        }
        .global-module__city {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            width: 100%;
        }
        .global-module__3 {
            flex: 0 0 20%;
        }
    }

    .global-module__city-name {
        line-height: normal;
        font-size: 18px;
        font-family: "pingfang sc bold", "pingfang heavy", "Microsoft YaHei", sans-serif;
        flex: 0 0 60px;
        align-self: center;
    }

    .global-module__city-img {
        overflow: hidden;
        max-width: 188px;
        flex: 0 0 auto;

        img { width: 100%; height: 100%; object-fit: contain; }
    }

    .global-module__city-types {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex: 1;
        gap: 10px;
    }

    .global-module__city-type-img {
        width: 22px;
        height: 22px;
        object-fit: contain;
        flex-shrink: 0;
    }
}

@media screen and (max-width: 768px) {
    .global-module {
        .global-module__cn {
            font-size: 28px;
            line-height: 1;
            margin-bottom: 5px;
        }
        .global-module__desc {
            font-size: 14px;
            line-height: 1.5;
            margin-top: 10px;
        }
        .global-module__world-inner {
            flex-direction: column;
        }
        .global-module__world-left {
            flex: 0 0 100%;
            padding-right: 0;
            margin-right: 0;
        }
        .global-module__world-right {
            flex: 0 0 100%;
        }
        .global-module__world-img {
            max-height: none;
            min-height: 0;
        }
        .global-module__headquarters {
            flex-direction: column;
            margin-bottom: 12%;
        }
        .global-module__headquarters-img {
            width: 100%;
            flex: 0 0 auto;
        }
        .global-module__headquarters-text{
           padding: 20px 0;
           width: 85%;
           margin: auto;
        }
        .global-module__head-city {
            font-size: 28px;
            line-height: 1;
        }
        .global-module__head-title {
            margin-top: 10px;
            font-size: 20px;
        }

        //  类型
        .global-module__type-img{
            width: 35px;
        }
        .global-module__type-name{
            font-size: 18px;
        }
        .global-module__type-card{
            margin-bottom: 2%;
        }


        .global-module__cities-inner {
            flex-direction: column !important;
        }
        .global-module__city {
            flex: 0 0 100%;
            margin-bottom: 10px;
        }
        .global-module__city-type-img{
          width: 32px;
          height: auto;
        }
        .global-module__city-name {
            font-size: 18px;
        }
    }
}


</style>
